import React from "react";
import { useTranslation } from "react-i18next";
import Card from "components/card/Card";
import { EmailCampaignScheduleOptions } from "./EmailCampaignScheduleOptions";
import {
  TEmailCampaignScheduleFields,
  updateEmailCampaignScheduleDate,
  updateEmailCampaignScheduleRecurringType,
  updateEmailCampaignScheduleTime,
  updateEmailCampaignScheduleType,
} from "./emailCampaignScheduleState";

export type { TEmailCampaignScheduleFields } from "./emailCampaignScheduleState";
export { isEmailCampaignScheduleCompleteFromCampaign } from "./emailCampaignScheduleState";

type TEmailCampaignScheduleFormProps = {
  value: TEmailCampaignScheduleFields;
  onChange: (value: TEmailCampaignScheduleFields) => void;
};

export function EmailCampaignScheduleForm(props: TEmailCampaignScheduleFormProps) {
  const { value, onChange } = props;

  return (
    <EmailCampaignScheduleOptions
      value={value}
      onSelectType={type => onChange(updateEmailCampaignScheduleType(value, type))}
      onScheduledDateChange={date => onChange(updateEmailCampaignScheduleDate(value, date))}
      onScheduledTimeChange={time => onChange(updateEmailCampaignScheduleTime(value, time))}
      onRecurringTypeChange={type => onChange(updateEmailCampaignScheduleRecurringType(value, type))}
    />
  );
}

type TEmailCampaignSchedulePanelProps = {
  value: TEmailCampaignScheduleFields;
  onChange: (value: TEmailCampaignScheduleFields) => void;
};

export default function EmailCampaignSchedulePanel(props: TEmailCampaignSchedulePanelProps) {
  const { t } = useTranslation();
  const { value, onChange } = props;

  return (
    <Card>
      <Card.Section>
        <div className="text-lg font-semibold mb-2">{t("Schedule settings")}</div>
        <div className="text-md text-gray-600 border-b border-b-gray-200 pb-3 mb-4" />
        <EmailCampaignScheduleForm value={value} onChange={onChange} />
      </Card.Section>
    </Card>
  );
}
